<template>
 <page>

   <head-nav title="language.add_calendar_item">
      <icon-button-back slot="left"></icon-button-back>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>

<scroll-page>
    <page-padding>
      <ui-input title="language.date" type="date" v-bind:val="date" @input="(v)=>{date = v}"></ui-input>
      <ui-input title="language.time_from" type="time" v-bind:val="timeFrom" @input="(v)=>{timeFrom = v}"></ui-input>
      <ui-input title="language.time_to" type="time" v-bind:val="timeTo" @input="(v)=>{timeTo = v}"></ui-input>
      <ui-input title="language.title" type="text" v-bind:val="title" @input="(v)=>{title = v}"></ui-input>
      <ui-textarea title="language.provide_description" v-bind:val="description" @input="(v)=>{description = v}"></ui-textarea>
      
      <divider title=""/> 
      <button-activate :active="buttonActive" v-on:click.native="confirm()" :title="computeTitle"></button-activate>
     </page-padding>
</scroll-page>  
   </page>
</template>

<script>

import { mapState } from 'vuex';
import Page from '../pages/Page.vue';
import ButtonActivate from '../components/buttons/ButtonActivate.vue';
import PagePadding from '../components/PagePadding.vue';
import ScrollPage from '../components/ScrollPage.vue';
import HeadNav from '../components/HeadNav.vue';
import IconButtonHome from '../components/buttons/IconButtonHome.vue';
import IconButtonBack from '../components/buttons/IconButtonBack.vue';
import UiInput from '../components/UiInput.vue';
import UiTextarea from '../components/UiTextarea.vue';
import { modalService } from '../services/ModalService.js';
import i18n from "../language.js";
import { history } from "../services/History.js";
import Divider from '../components/dividers/Divider.vue';


export default {
  name: 'add-calendar-item-page',
  data:function(){
    return{
      id:this.$route.params.id,
      title:"",
      description:"",
      buttonActive:true,
      date:"",
      timeFrom:"",
      timeTo:""
    }
  },
  computed:{
     ...mapState([
       'calendar'
       ]),
       computeTitle(){
        if(!this.buttonActive){
          return this.$t('language.working');
        }else{
           return this.$t('language.add_calendar_item');
        }
      }
  },
  components: {
    ButtonActivate,
    PagePadding,
    HeadNav,
    IconButtonHome,
    IconButtonBack,
    UiInput,
    UiTextarea,
    Page,
    ScrollPage,
    Divider,
  },
  methods:{
    back(){
      this.$router.push(history.get());
    },
    isFormComplete(){
      
      if(this.date===""){
          modalService.createAlert(i18n.t('language.form_incomplete_date'))
        return false;
      }

      if(this.title===""){
          modalService.createAlert(i18n.t('language.form_incomplete_title'))
        return false;
      }


      return true
    },
    initForm(){
      // set date to today;
      var today=new Date();
      var year=today.getFullYear();
      var month=(today.getMonth()+101).toString().slice(-2);
      var day=(today.getDate()+100).toString().slice(-2);
      // set date?
      this.date= year+"-"+month+"-"+day;

      var time = new Date();
      var hours = (time.getHours()+100).toString().slice(-2);
      var minutes = (time.getMinutes()+100).toString().slice(-2);
      time= hours+":"+minutes;

      //this.timeFrom=time;
      //this.timeTo=time;
    },
    clearForm(){
      this.title="";
      this.description="";

      // we done here lets go back
      this.back();
    }, 
    convert_date_nl(){
      var date_us=this.date.split("-"); // yyyy-mm-dd;
      var date_nl=date_us[2]+'-'+date_us[1]+'-'+date_us[0]; // dd-mm-yyyy
      return date_nl;
    },
    confirm(){
    
      if(!this.isFormComplete()){
        return;
      }

     this.buttonActive=false;
     setTimeout(()=>{
       this.callApi();
      },500);

    },
    callApi(){

       var payload={
        id:this.id,
        date:this.convert_date_nl(),
        time:this.timeFrom,
        end_time:this.timeTo,
        title:this.title,
        description:this.description,
      }

      // gets dummy promise that always resolves
      this.$store.dispatch('add_calendar_item',payload).then(
        ()=>{
          this.buttonActive=true;
          this.clearForm();
        }
      )
      


    },
    
  },
  created(){
    this.initForm();
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
